import React from 'react'
import withStyles from 'react-jss'
import PlayerBodyRateOptions from '../../../../modules/user-rating/player-body-rate-options'
import { StateConsumer } from '../../state'
import { ControlConsumer } from '../../control'
import { GaConsumer } from '../../ga/ga-core'
import PauseButton from './pause-button'
import SettingsPanel from './settings-panel'
import { E2E_SELECTORS } from '../../../../e2e-selectors'
import PlanUpgradePopup from '../../../modals/plan-upgrade-popup/plan-upgrade-popup'

const styles = {
  wrapper: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    order: 1
  }
}

function Body({ classes }) {
  const rateOptionClicked = React.useRef(false)
  const setRateOptionClicked = React.useCallback(() => { rateOptionClicked.current = true }, [])

  const showPopup = (pause, setIsQualityUpgradePopupShown) => {
    pause()
    setIsQualityUpgradePopupShown(true)
  }

  const onPopupDismiss = (
    play,
    emitPlayDataLayerEvent,
    setIsQualityUpgradePopupShown
  ) => {
    play()
    emitPlayDataLayerEvent()
    setIsQualityUpgradePopupShown(false)
  }

  const onPopupConfirm = pause => {
    pause()
  }

  return (
    <StateConsumer>
      {({
        isFullscreen,
        isPlaying,
        isSettingsPanelOpen,
        toggleSettingsPanelOpen,
        setIsVolumeBarVisible,
        appConfig,
        setIsQualityUpgradePopupShown,
        isQualityUpgradePopupShown,
        contentItem,
        isTrailer,
        isAdOnPauseShown,
        isPlayingAd,
        isEpisodeSelectorOpen,
        isBannerRateModalShowing,
        isNextEpisodeCountdownShowing,
        currentTime
      }) => (
        <ControlConsumer>
          {({
            enterFullscreen, exitFullscreen, play, pause
          }) => {
            const shouldDisplayUserRating =
              !isTrailer &&
              !isAdOnPauseShown &&
              !isPlayingAd &&
              currentTime > 1 && // isPlayingAd is not yet set to true in the very beginning, so we don't want to show the user rating options too early(< 1s) while ads start playing
              !isEpisodeSelectorOpen &&
              !isBannerRateModalShowing &&
              !isNextEpisodeCountdownShowing
            return (
              <GaConsumer>
                {({ emitPlayDataLayerEvent }) => (
                  <div
                    className={classes.wrapper}
                    data-lbx-e2e={E2E_SELECTORS.VIDEO_BODY}
                    onClick={() => {
                      if (!isQualityUpgradePopupShown) {
                        if (isSettingsPanelOpen) {
                          toggleSettingsPanelOpen()
                          return
                        }
                        // when clicking RateOption, we don't want to toggle play/pause
                        if (rateOptionClicked.current) {
                          rateOptionClicked.current = false
                          return
                        }
                        if (isPlaying) {
                          pause()
                        } else {
                          play()
                          emitPlayDataLayerEvent()
                        }
                        setIsVolumeBarVisible(false)
                      }
                    }}
                    onDoubleClick={() => {
                      if (!isQualityUpgradePopupShown) {
                        if (isFullscreen) {
                          exitFullscreen()
                        } else {
                          enterFullscreen()
                        }
                      }
                    }}
                  >
                    <PauseButton />

                    {shouldDisplayUserRating && (
                      <PlayerBodyRateOptions
                        contentItem={contentItem}
                        shouldDisplayUserRating={shouldDisplayUserRating}
                        setRateOptionClicked={setRateOptionClicked}
                      />
                    )}

                    {isQualityUpgradePopupShown && (
                      <PlanUpgradePopup
                        appConfig={appConfig}
                        isQualityUpgradePopupShown={isQualityUpgradePopupShown}
                        onPopupDismiss={() => onPopupDismiss(
                          play,
                          emitPlayDataLayerEvent,
                          setIsQualityUpgradePopupShown
                        )}
                        onPopupConfirm={() => onPopupConfirm(pause)}
                      />
                    )}
                    <SettingsPanel
                      showQualityUpgradePopup={() => showPopup(pause, setIsQualityUpgradePopupShown)}
                    />
                  </div>
                )}
              </GaConsumer>
            )
          }}
        </ControlConsumer>
      )}
    </StateConsumer>
  )
}

export default withStyles(styles)(Body)
